@let p = profile();
@let bioText = (p?.bio | translateData) || '';
<article class="installer-profile-card">
  <div class="installer-profile-card__media">
    <img
      class="installer-profile-card__logo"
      [ngSrc]="
        p?.logo ?? ''
          | imageSource: true : 'md' : logoPlaceholder
      "
      [width]="120"
      [height]="120"
      [alt]="p?.title | translateData" />
  </div>
  <div class="installer-profile-card__body">
    <div class="installer-profile-card__heading">
      <div class="installer-profile-card__heading-main">
        @if (showFirstName()) {
          <p class="installer-profile-card__first-name">
            {{ firstName() }}
          </p>
        }
        @if ((p?.title | translateData); as profileTitle) {
          @if (profileTitle && profileTitle !== '-') {
            <h3 class="installer-profile-card__title">
              {{ profileTitle }}
            </h3>
          }
        }
      </div>
      <span class="installer-profile-card__type">{{ typeTranslationKey() | translate }}</span>
    </div>
    @if (p?.exact_role) {
      <p class="installer-profile-card__role">{{ p.exact_role }}</p>
    }
    @if (showBio(bioText)) {
      <p
        class="installer-profile-card__bio"
        [class.people-profile-card-locked]="isBioLocked(bioText)">
        @if (isBioLocked(bioText)) {
          {{ bio(bioText) }}
        } @else {
          {{ bioText.length > 120 ? bioText.slice(0, 120) + '…' : bioText }}
        }
      </p>
    }
    <div class="installer-profile-card__meta">
      @if (showRegion()) {
        <span
          class="installer-profile-card__meta-item"
          [class.people-profile-card-locked]="isRegionLocked()">
          <span aria-hidden="true">📍</span> {{ region() }}
        </span>
      }
      @if (showContact()) {
        @if (email(); as contactEmail) {
          @if (isEmailLocked()) {
            <span
              class="installer-profile-card__meta-item people-profile-card-locked">
              {{ contactEmail }}
            </span>
          } @else {
            <a
              [href]="'mailto:' + contactEmail"
              class="installer-profile-card__meta-link">
              {{ contactEmail }}
            </a>
          }
        }
        @if (phone(); as contactPhone) {
          <span
            class="installer-profile-card__meta-item"
            [class.people-profile-card-locked]="isPhoneLocked()">
            {{ contactPhone }}
          </span>
        }
      }
    </div>
    @if ((p?.categories?.length ?? 0) > 0) {
      <div class="installer-profile-card__tags">
        @for (cat of (p?.categories ?? []).slice(0, 4); track cat._id) {
          <span class="installer-profile-card__tag">{{
            cat?.title | translateData
          }}</span>
        }
      </div>
    }
    <div class="installer-profile-card__badges">
      @if (p?.bim_ready) {
        <span class="installer-profile-card__badge">BIM</span>
      }
      @if (p?.warranty_provided) {
        <span class="installer-profile-card__badge">{{
          'industries.warranty' | translate
        }}</span>
      }
    </div>
  </div>
</article>
